import React, { useRef, useEffect } from 'react';
import SupportLitResultItem from './SupportLitResultItem';
import Pagination from '../pagination/Pagination';
import styles from './results.module.css';
import PropTypes from 'prop-types';

const propTypes = {
  supportLit: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object.isRequired),
    fullCount: PropTypes.number,
    page: PropTypes.number,
  }).isRequired,
  searchFlag: PropTypes.bool.isRequired,
  onPageChange: PropTypes.func.isRequired,
  pageChangeLoading: PropTypes.object.isRequired,
  searchErrors: PropTypes.object.isRequired,
  perPage: PropTypes.number.isRequired,
};

export default function SupportLitResults({
  supportLit,
  onPageChange,
  pageChangeLoading,
  searchErrors,
  perPage,
}) {
  const supportLitRef = useRef(null);

  useEffect(() => {
    const handleHashChange = () => {
      const hashValue = window.location.hash.slice(1);
      if (hashValue === 'suplit' && supportLitRef.current) {
        supportLitRef.current.open = true;
        supportLitRef.current.scrollIntoView();
      }
    };
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  const supportLitItems = supportLit.results.map((lit) => (
    <li key={lit._id}>
      <SupportLitResultItem supportLitItem={lit} isOpen={false} />
    </li>
  ));

  return (
    <div>
      {!!supportLitItems.length && (
        <details open={false} ref={supportLitRef} aria-label="support literature results">
          <summary className={`${styles.summarySection} ${styles.supHeader}`}>
            <span style={{ backgroundColor: '#68ae9f', color: '#68ae9f', display: 'inline-block' }}>
              &nbsp;
            </span>
            <span style={{ marginLeft: '2px' }}>
              <strong>Support Literature</strong>
            </span>
          </summary>
          {supportLitItems}
          {searchErrors.support && <p className={styles.error}>{searchErrors.support}</p>}
          <Pagination
            fullCount={supportLit.fullCount}
            perPage={perPage}
            currentPage={supportLit.page}
            onPageChange={(newPage) => onPageChange('support', newPage)}
            disabled={!!pageChangeLoading.support}
          />
        </details>
      )}
    </div>
  );
}

SupportLitResults.propTypes = propTypes;
